import React from 'react';
import { FaCircleXmark } from "react-icons/fa6";
import { HiRefresh } from "react-icons/hi";

const Incorrect = ({ message, handleReset }) => {
  return (
    <div className='incorrect-answer'>
        <p><FaCircleXmark /> {message}</p>
        <button className='button button-incorrect' onClick={handleReset}><HiRefresh /> Intentar de nuevo</button>
    </div>
  );
};

export default Incorrect;